// http://coveroverflow.com/a/11381730/989439
function mobilecheck() {
	const check = (a) => {
		if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
			return true;
		}
		return false;
	}

	//;
	
	return check(navigator.userAgent || navigator.vendor || window.opera);
}

// Reference http://davidwalsh.name/essential-javascript-functions

// Debounce
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	let timeout;
	return function () {
        const context = this;
        const args = arguments;

        const later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = (immediate && !timeout);
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
			func.apply(context, args);
		}
    };
}

/* Usage
	var myEfficientFn = debounce(function() {
	// All the taxing stuff you do
	}, 250);
	window.addEventListener('resize', myEfficientFn);
	*/

//Poll
function poll(fn, callback, errback, timeout, interval) {
	const endTime = Number(new Date()) + (timeout || 2000);
	interval = interval || 100;

	(function p() {
		// If the condition is met, we're done!
		if (fn()) {
			callback();
		} else if (Number(new Date()) < endTime) {
			// If the condition isn't met but the timeout hasn't elapsed, go again
			setTimeout(p, interval);
		} else {
			// Didn't match and too much time, reject!
			errback(new Error(`timed out for ${fn}: ${arguments}`));
		}
	}());
}

// Usage:  ensure element is visible
/*poll(
	function() {
	return document.getElementById('lightbox').offsetWidth > 0;
	},
	function() {
	// Done, success callback
	},
	function() {
	// Error, failure callback
	}
	);
	*/

// Once
// There are times when you prefer a given functionality only happen once,
// similar to the way you'd use an onload event
// The once function ensures a given function can only be called once, thus prevent duplicate initialization!
function once(fn, context) {
	let result;

	return function () {
		if (fn) {
			result = fn.apply(context || this, arguments);
			fn = null;
		}

		return result;
	};
}

const executeFunctionByName = function (functionName, context) {
    /*
	http://stackoverflow.com/questions/359788/how-to-execute-a-javascript-function-when-i-have-its-name-as-a-string
	The benefit of this method is to pass a function as a name that may be passed as a object-reference.
	The functionName can be anObject.aSubObject.aMethod,
	After the context-argument additional arguments may be passed:
	i.e executeFunctionByName('anObject.aSubObject.aMethod', aWrappingObject, 'arg1','arg2','argN')
	This method then goes from the parent-object to into the separate
	subobjects and replaces the context with the
	last one:
	(selectedContext = context['anObject']['aSubObject'])
	Finally the last key ('aMethod') is referred to from inside its closest parent-object, and invoked with its passed arguments.

*/
    let i;

    let additionalArgs = [].slice.call(arguments).splice(2);
    let namespaces = functionName.split('.');
    let func = namespaces.pop();
    let ctx = (context || window);
    // context = (context || window);
    for (i = 0; i < namespaces.length; i += 1) {
		ctx = ctx[namespaces[i]];
		// context = context[namespaces[i]];
	}
    return ctx[func].apply(ctx, additionalArgs);
};

// Usage
/*var canOnlyFireOnce = once(function() {
 console.log('Fired!');
 });
 canOnlyFireOnce(); // "Fired!"
 canOnlyFireOnce(); // nada
 */

// getAbsoluteUrl
// getting an absolute URL from and string input
const getAbsoluteUrl = (function () {
              // Usage
              /*
              getAbsoluteUrl('/something'); // http://davidwalsh.name/something
              */
              let a;

              return function (url) {
                  if (!a) {
                      a = document.createElement('a');
                  }
                  a.href = url;

                  return a.href;
              };
          }());

const containsWord = function (string, word) {
    /*eventhandling system copied from payment/common/lib/utils/events.js*/
    return new RegExp(`\\b${word}\\b`).test(string);
};

const checkParentForFilterHit = function (element, filter, addFilter) {
    let node = element;
    let additionalFilterHit = false;
    let parentNode = node.parentNode;
    let className = element.className;
    let wrapFilterHit = false;
    let wrapFilter = 'adcont';
    let seq = 0;
    let parentTargetHit = false;
    while (parentNode !== null && !(seq > 15 || wrapFilterHit || parentTargetHit)) {
        node = parentNode;
        className = parentNode.className;
        parentTargetHit = containsWord(className, filter);
        wrapFilterHit = containsWord(className, wrapFilter);
        if (!additionalFilterHit) {
            additionalFilterHit = containsWord(className, addFilter);
        }
        seq += 1;
        parentNode = node.parentNode;
    }
    return {
        filterHit: parentTargetHit,
        targetElem: node,
        className
    };
};

const handle = function (e, classSelectorFilter, sendFkn, checkParent) {
    const handler = (function () {
        e = e || window.event;
        let targetElem = e.target || e.srcElement;
        let filterHit = false;
        let className = targetElem.className;
        let data = e.detail;
        let checkParentObj;
        let filterClassName = classSelectorFilter.slice(1);
        filterHit = containsWord(className, filterClassName);
        if (!filterHit && checkParent) {
            checkParentObj = checkParentForFilterHit(targetElem, filterClassName);
            filterHit = checkParentObj.filterHit;
            className = checkParentObj.className;
            targetElem = checkParentObj.targetElem;
        }
        if (filterHit && sendFkn) {
            sendFkn({
                elm: targetElem,
                data,
                e
            });
        }
        return {
            getEventObj() {
                return {
                    className,
                    data,
                    filterHit,
                    filter: filterClassName
                };
            }
        };
    }());
    return handler;
};

const utils = {
	eventhandler(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
		return handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
	},
	mobilecheck,
	getAbsoluteUrl,
	once,
	poll,
	debounce,
	executeFunctionByName
};

export default utils;



// WEBPACK FOOTER //
// ./mobile-core/src/utils.js